import LayoutBottom from './LayoutBottom'

export default LayoutBottom
